import { API_TYPE } from '@umu/umu-fetch';
export const PermissionPageApi = {
    GET_PERMISSION_OPTION: {
        url: `/api/group/getAccessPermissionOption`, // 获取资源权限类型
        type: API_TYPE.GET,
    },
}
